import { render, staticRenderFns } from "./AccStatementIcon.vue?vue&type=template&id=67125826&"
import script from "./AccStatementIcon.vue?vue&type=script&lang=js&"
export * from "./AccStatementIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67125826')) {
      api.createRecord('67125826', component.options)
    } else {
      api.reload('67125826', component.options)
    }
    module.hot.accept("./AccStatementIcon.vue?vue&type=template&id=67125826&", function () {
      api.rerender('67125826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/income/AccStatementIcon.vue"
export default component.exports